export interface IFormAuth {
  email: string;
  password: string;
}

export const formAuth: IFormAuth = {
  email: '',
  password: '',
};
